import { CheckoutWidgetsConfigSchema } from "@redotech/redo-model/checkouts/widget";
import * as z from "zod/v4";

export const getGlobalCheckoutWidgetsConfig = {
  name: "getGlobalCheckoutWidgetsConfig" as const,
  input: z.null(),
  output: CheckoutWidgetsConfigSchema,
};
